import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import HandleDeleteVeridasApp from './HandleDeleteVeridasApp';
import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * Component to handle the effect of clicking the browser's "Back" button. If the button is clicked,
 * a confirmation message is displayed. If the user confirms, all registered information—such as the uploaded INE/passport
 * and selfie—will be deleted. Otherwise, the data will be preserved and the user can continue with the process.
 *
 * @param model getInvitationById: Model that contains all the information of the invitation.
 */
const useBackNavigation = ({ getInvitationById , validationId }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const [isRedirected, setIsRedirected] = useState(false);

    const { handleDelete, handleDeleteStorage, handleGetUrl } = HandleDeleteVeridasApp({ getInvitationById , validationId });


    useEffect(() => {
        const pushFakeEntry = () => {
            window.history.pushState(null, '', window.location.pathname);
        };

        pushFakeEntry();

        const handlePopState = (e) => {
            e.preventDefault();

            const confirmed = window.confirm(t("are_you_sure_you_want_to_leave_and_delete_the_data"));

            if (confirmed) {
                const url = handleGetUrl();
                handleDelete?.();
                toast.warn(t("all_the_recorded_information_was_lost"));
                navigate(url);
                handleDeleteStorage();
                setIsRedirected(true);
            } else {
                pushFakeEntry();
            }
        };

        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [navigate, handleDelete]);

    return { isRedirected }
};

export default useBackNavigation;
